export const CALENDAR_TYPES = {
  EDUCATION: {
    id: "education",
    label: "Education",
  },
  HOLIDAY: {
    id: "holiday",
    label: "Holiday",
  },
};

export const CALENDAR_DATE_TYPES = {
  REGULAR: {
    id: "regular",
    label: "Regular",
    color: "green",
  },
  HOLIDAY: {
    id: "holiday",
    label: "Holiday",
    color: "red",
  },
  INSET: {
    id: "inset",
    label: "INSET",
    color: "orange",
  },
};
